import { useTranslation } from 'react-i18next';

import { negotiationStatus, screenType } from './enum';

export const negotiationStatusText = (
  statusNum: number,
  screen: number
): string => {
  const { t } = useTranslation();
  if (screen === screenType.client) {
    if (statusNum === negotiationStatus.inquiries)
      return t('message.clientStatus.1');
    if (statusNum === negotiationStatus.like)
      return t('message.clientStatus.2');
    if (statusNum === negotiationStatus.likeApproved)
      return t('message.clientStatus.3');
    if (statusNum === negotiationStatus.proposalPreparation)
      return t('message.clientStatus.4');
    if (statusNum === negotiationStatus.negotiation)
      return t('message.clientStatus.5');
    if (statusNum === negotiationStatus.order)
      return t('message.clientStatus.6');
    if (statusNum === negotiationStatus.orderApproval)
      return t('message.clientStatus.7');
    if (statusNum === negotiationStatus.invoice)
      return t('message.clientStatus.8');
    if (statusNum === negotiationStatus.likeRejected)
      return t('message.clientStatus.9');
    if (statusNum === negotiationStatus.decline)
      return t('message.clientStatus.10');
    if (statusNum === negotiationStatus.preparation)
      return t('message.clientStatus.11');
    if (statusNum === negotiationStatus.posted)
      return t('message.clientStatus.12');
    return '';
  } else if (screen === screenType.publisher) {
    if (statusNum === negotiationStatus.inquiries)
      return t('message.publisherStatus.1');
    if (statusNum === negotiationStatus.like)
      return t('message.publisherStatus.2');
    if (statusNum === negotiationStatus.likeApproved)
      return t('message.publisherStatus.3');
    if (statusNum === negotiationStatus.proposalPreparation)
      return t('message.publisherStatus.4');
    if (statusNum === negotiationStatus.negotiation)
      return t('message.publisherStatus.5');
    if (statusNum === negotiationStatus.order)
      return t('message.publisherStatus.6');
    if (statusNum === negotiationStatus.orderApproval)
      return t('message.publisherStatus.7');
    if (statusNum === negotiationStatus.invoice)
      return t('message.publisherStatus.8');
    if (statusNum === negotiationStatus.likeRejected)
      return t('message.publisherStatus.9');
    if (statusNum === negotiationStatus.decline)
      return t('message.publisherStatus.10');
    if (statusNum === negotiationStatus.preparation)
      return t('message.publisherStatus.11');
    if (statusNum === negotiationStatus.posted)
      return t('message.publisherStatus.12');
    return '';
  } else if (screen === screenType.agent) {
    if (statusNum === negotiationStatus.inquiries)
      return t('message.agentStatus.1');
    if (statusNum === negotiationStatus.like) return t('message.agentStatus.2');
    if (statusNum === negotiationStatus.likeApproved)
      return t('message.agentStatus.3');
    if (statusNum === negotiationStatus.proposalPreparation)
      return t('message.agentStatus.4');
    if (statusNum === negotiationStatus.negotiation)
      return t('message.agentStatus.5');
    if (statusNum === negotiationStatus.order)
      return t('message.agentStatus.6');
    if (statusNum === negotiationStatus.orderApproval)
      return t('message.agentStatus.7');
    if (statusNum === negotiationStatus.invoice)
      return t('message.agentStatus.8');
    if (statusNum === negotiationStatus.likeRejected)
      return t('message.agentStatus.9');
    if (statusNum === negotiationStatus.decline)
      return t('message.agentStatus.10');
    if (statusNum === negotiationStatus.preparation)
      return t('message.agentStatus.11');
    if (statusNum === negotiationStatus.posted)
      return t('message.agentStatus.12');
    return '';
  }
  return '';
};
